var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.581 10.4434L22.5853 9.43911C23.3842 8.64022 23.833 7.5567 23.833 6.4269C23.833 5.2971 23.3842 4.21358 22.5853 3.41469C21.7864 2.6158 20.7029 2.16699 19.5731 2.16699C18.4433 2.16699 17.3597 2.6158 16.5609 3.41469L15.5566 4.41894L6.32444 13.6489C5.69936 14.2751 5.38627 14.5882 5.11761 14.9327C4.80061 15.3395 4.52856 15.7793 4.30619 16.2446C4.11877 16.6389 3.97902 17.0593 3.69952 17.8978L2.51436 21.4522M21.581 10.4434C21.581 10.4434 19.4479 10.3177 17.5651 8.43486C15.6823 6.55311 15.5577 4.41894 15.5577 4.41894M21.581 10.4434L12.3499 19.6734C11.7249 20.2984 11.4118 20.6115 11.0673 20.8802C10.6605 21.1972 10.2206 21.4692 9.75536 21.6916C9.36102 21.879 8.94177 22.0188 8.10219 22.2983L4.54777 23.4834M4.54777 23.4834L3.67894 23.7738C3.47641 23.8417 3.25896 23.8518 3.05103 23.8029C2.84309 23.754 2.65291 23.6481 2.50187 23.497C2.35082 23.346 2.2449 23.1558 2.19601 22.9479C2.14712 22.7399 2.1572 22.5225 2.22511 22.3199L2.51544 21.4511L4.54777 23.4834Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.bb6ec1dd725d4bd57e4590c06630b579.svg";
export { ForwardRef as ReactComponent };